module.exports = __webpack_public_path__ + "static/img/021_TO8_1496.b37277c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/021_TO8_1496.jpg
// module id = m9Sm
// module chunks = 0